import React, { useState } from 'react';
import { InfoWindow, Marker } from '@react-google-maps/api';
import moment from 'moment';
import markerImg from './map-icons/unloading-marker.png';

const RendezvousMapMarker = ({ point }) => {
  const { ID, SampleTime: date, Longitude, Latitude, Driver } = point;
  const [showInfo, setShowInfo] = useState(true);
  const href = `https://www.google.com/maps/place/${Latitude},${Longitude}`;

  return (
    <Marker
      key={ID}
      icon={markerImg}
      onClick={() => setShowInfo(!showInfo)}
      position={{
        lat: Latitude,
        lng: Longitude,
      }}
    >
      {showInfo && (
        <InfoWindow options={{ disableAutoPan: true }} onCloseClick={() => setShowInfo(!showInfo)}>
          <div style={{ color: 'black' }}>
            <div>Begin Unload</div>
            <div>{moment(date).format('MM/DD/YYYY hh:mm A z')}</div>
            {Driver && <div>Driver: {Driver}</div>}
            <div>
              <a target={'_blank'} href={href}>
                Coordinates: {Latitude},{Longitude}
              </a>
            </div>
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default RendezvousMapMarker;
